var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"make-box"},[(_vm.moduleId === 12)?_c('HomeMake'):_vm._e(),(_vm.moduleId === 13)?_c('DetailPagesMake'):_vm._e(),(_vm.moduleId === 14)?_c('CustomPageMake'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }